<template>
  <div>
    <h3>Rename this model</h3>
    <form v-on:submit.prevent="updateModelname">
      <input type="hidden" name="modelId" v-bind:value="modelId">
      <div class="sw--margin-bottom-4 sw--width-full">
        <input ref="modelNameInput" type="text" name="title" v-bind:placeholder="modelName" v-model="newModelName" class="sw--width-full">
      </div>

      <div class="sw-grid-flex sw-grid-flex--align-center">
        <div class="sw--margin-left-auto">
          <a event-category="MMC" event-action="Tools Rename" event-label="Cancel"><span class="sw-dms--color-black sw--text-decoration-underline sw--uppercase sw--font-size-14" v-on:click.prevent="closeNoty">Cancel</span></a>
        </div>
        <div class="sw--margin-left-4">
          <button class="sw-dms-button sw-dms-button--red" event-category="MMC" event-action="Tools Rename" event-label="Ok"><span class="sw--padding-hor-2 sw--font-size-16">OK</span></button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import sw from 'js/lib/sw';
  import $ from 'js/sw-jquery/sw-jquery';

  export default {
      name: 'sw-model-rename',
      props: {
          'modelId': { type: Number, required: true },
          'modelName': String,
          'notyId': { type: String, required: true }
      },
      data() {
          return {
              newModelName: null
          }
      },
      mounted() {
          // Focus the cursor on the new model name input once the vue is mounted
          this.$nextTick(() => {
              this.$refs.modelNameInput.focus();
          });
      },
      methods: {
          closeNoty() {
              sw.trigger('sw-noty-close', this.notyId);
          },
          updateModelname(event) {
              const formData = $(event.target).swFormValues();

              $.post('/model/edit/title', formData).done(response => {
                  if (JSON.parse(response).success === true) {
                      // Refresh the page to see the update model name
                      window.location.reload();
                  } else {
                      sw.notifications.error('The model name could not be changed.');
                  }
              });
          }
      }
  }
</script>
